 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","firebase-messaging":"firebase-messaging","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","ui-pages-forgot-password-forgot-password-module":"ui-pages-forgot-password-forgot-password-module","ui-pages-login-login-module":"ui-pages-login-login-module","ui-pages-main-main-module":"ui-pages-main-main-module","ui-pages-main-payment-result-payment-result-module":"ui-pages-main-payment-result-payment-result-module","ui-pages-maintenance-maintenance-module":"ui-pages-maintenance-maintenance-module","ui-pages-pdpa-term-condition-pdpa-term-condition-module":"ui-pages-pdpa-term-condition-pdpa-term-condition-module","ui-pages-register-register-module":"ui-pages-register-register-module","ui-pages-sery-sery-module":"ui-pages-sery-sery-module","ui-pages-terms-and-conditions-terms-and-conditions-module":"ui-pages-terms-and-conditions-terms-and-conditions-module","swiper-bundle-44a9b1f9-js":"swiper-bundle-44a9b1f9-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-73f15161-js":"input-shims-73f15161-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-bdecfebf-js":"status-tap-bdecfebf-js","swipe-back-ee838cf8-js":"swipe-back-ee838cf8-js","tap-click-cc1ae2b2-js":"tap-click-cc1ae2b2-js","admin-admin-module":"admin-admin-module","bank-account-bank-account-module":"bank-account-bank-account-module","change-password-change-password-module":"change-password-change-password-module","transactions-deposit-physical-gold-deposit-physical-gold-module":"transactions-deposit-physical-gold-deposit-physical-gold-module","default~admin-individual-commission-individual-commission-module~admin-refunds-user-refunds-user-ref~f6577a87":"default~admin-individual-commission-individual-commission-module~admin-refunds-user-refunds-user-ref~f6577a87","admin-individual-commission-individual-commission-module":"admin-individual-commission-individual-commission-module","ask-payout-ask-payout-module":"ask-payout-ask-payout-module","home-home-module":"home-home-module","item-list-item-list-module":"item-list-item-list-module","withdraw-digital-withdraw-digital-module":"withdraw-digital-withdraw-digital-module","default~admin-refunds-user-refunds-user-refunds-module~refunds-refunds-module~transactions-history-h~db1b5b44":"default~admin-refunds-user-refunds-user-refunds-module~refunds-refunds-module~transactions-history-h~db1b5b44","admin-refunds-user-refunds-user-refunds-module":"admin-refunds-user-refunds-user-refunds-module","default~ask-receipt-ask-receipt-module~refund-receipt-refund-receipt-module~transactions-buy-physica~3fe42af5":"default~ask-receipt-ask-receipt-module~refund-receipt-refund-receipt-module~transactions-buy-physica~3fe42af5","transactions-confirmation-confirmation-module":"transactions-confirmation-confirmation-module","ask-receipt-ask-receipt-module":"ask-receipt-ask-receipt-module","transactions-buy-physical-buy-physical-module":"transactions-buy-physical-buy-physical-module","transactions-withdraw-receipt-withdraw-receipt-module":"transactions-withdraw-receipt-withdraw-receipt-module","kyc-kyc-module":"kyc-kyc-module","notification-list-notification-list-module":"notification-list-notification-list-module","profile-profile-module":"profile-profile-module","referral-referral-module":"referral-referral-module","register-ask-register-ask-module":"register-ask-register-ask-module","upgrade-kyc-upgrade-kyc-module":"upgrade-kyc-upgrade-kyc-module","wallet-wallet-module":"wallet-wallet-module","transactions-history-history-module":"transactions-history-history-module","transactions-buy-booking-booking-module":"transactions-buy-booking-booking-module","transactions-buy-buy-module":"transactions-buy-buy-module","transactions-sell-sell-module":"transactions-sell-sell-module","buy-sell-setting-buy-sell-setting-module":"buy-sell-setting-buy-sell-setting-module","commission-settings-commission-settings-module":"commission-settings-commission-settings-module","create-user-create-user-module":"create-user-create-user-module","booking-list-booking-list-module":"booking-list-booking-list-module","commission-commission-module":"commission-commission-module","kyc-list-kyc-list-module":"kyc-list-kyc-list-module","tenant-list-tenant-list-module":"tenant-list-tenant-list-module","user-list-user-list-module":"user-list-user-list-module","create-tenant-create-tenant-module":"create-tenant-create-tenant-module","dashboard-dashboard-module":"dashboard-dashboard-module","refunds-refunds-module":"refunds-refunds-module","payment-list-payment-list-module":"payment-list-payment-list-module","payout-history-payout-history-module":"payout-history-payout-history-module","promotion-list-promotion-list-module":"promotion-list-promotion-list-module","user-role-user-role-module":"user-role-user-role-module","markup-settings-markup-settings-module":"markup-settings-markup-settings-module","payment-detail-payment-detail-module":"payment-detail-payment-detail-module","promotion-promotion-module":"promotion-promotion-module","user-details-user-details-module":"user-details-user-details-module","verify-kyc-verify-kyc-module":"verify-kyc-verify-kyc-module","withdrawal-setting-withdrawal-setting-module":"withdrawal-setting-withdrawal-setting-module","my-digital-my-digital-module":"my-digital-my-digital-module","request-request-module":"request-request-module","canvg":"canvg","dompurify":"dompurify","html2canvas":"html2canvas","kyc-verify-kyc-verify-module":"kyc-verify-kyc-verify-module","buy-gold-buy-gold-module":"buy-gold-buy-gold-module","sell-gold-sell-gold-module":"sell-gold-sell-gold-module","refund-receipt-refund-receipt-module":"refund-receipt-refund-receipt-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
